import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useReactiveVar, useSuspenseQuery } from '@apollo/client/react'
import { Box, Typography } from '@mui/material'
import PropTypes from 'prop-types'

import { LocationBranding } from '../LocationBranding/LocationBranding'
import { LOCATION } from './locationQuery'

export const Header = ({ locationData, store }) => {
  const { locationId } = useReactiveVar(store)
  const { t } = useTranslation()
  const { data } = useSuspenseQuery(LOCATION, {
    variables: { id: locationId },
  })

  useEffect(() => {
    locationData(data.location)
  }, [data.location])

  return (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: 'var(--intelibly-branding-neutral-50)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '24px 20px',
        width: '100%',
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          alignSelf: 'stretch',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        {data && data.location && (
          <Box data-testid="location-info">
            <LocationBranding location={data.location} />
            <Typography align="center" color="secondary" variant="h6">
              {t('New Patient Exam')}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  )
}

Header.propTypes = {
  locationData: PropTypes.func,
  store: PropTypes.func,
}
